
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PoPo06PendingCNforCnrtvDialog extends Serenity.EntityDialog<PoPo06PendingCNforCnrtvRow, any> {
        protected getFormKey() { return PoPo06PendingCNforCnrtvForm.formKey; }
        protected getIdProperty() { return PoPo06PendingCNforCnrtvRow.idProperty; }
        protected getLocalTextPrefix() { return PoPo06PendingCNforCnrtvRow.localTextPrefix; }
        protected getNameProperty() { return PoPo06PendingCNforCnrtvRow.nameProperty; }
        protected getService() { return PoPo06PendingCNforCnrtvService.baseUrl; }
        protected getDeletePermission() { return PoPo06PendingCNforCnrtvRow.deletePermission; }
        protected getInsertPermission() { return PoPo06PendingCNforCnrtvRow.insertPermission; }
        protected getUpdatePermission() { return PoPo06PendingCNforCnrtvRow.updatePermission; }

        protected form = new PoPo06PendingCNforCnrtvForm(this.idPrefix);

        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
           buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
           buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
         
             let newCloseBtn: Serenity.ToolButton =
            {
                title: Q.text("ปิดเอกสาร"),
                hint: "Close Document",
                separator: false,
                cssClass: "closed-button",
                icon: "fa fa-save",
                onClick: (e) => {
                    Q.confirm('ยืนยันการปิดเอกสาร', () => {
                        // this.doDelete(() => {
                        console.log("Document Closed",this.form.SysDocNo.value);
                        //     this.dialogClose();
                        // });
                        Q.serviceRequest('Purchase/PoCreditNote/UpdateCancelAndUseFg', {
                            sysDocNo: this.form.SysDocNo.value,
                            CancelFg: "1",
                            UseFg: 1
                        }, response => {
                            Q.notifySuccess("ปิดเอกสารเรียบร้อยแล้ว");
                            this.dialogClose();
                        }, {
                            onError: (response) => {
                                Q.notifyError("เกิดข้อผิดพลาดในการปิดเอกสาร");
                            }
                        });

                    });
                }
            };
            buttons.push(newCloseBtn);
           return buttons;


   }
    }
}